<div class="bi-main-container">
  <div class="bi-container">
    <div class="bi-container__icon">
      <div
        [ngStyle]="getIcon()"
        [class]="
          biometricsDataService.generalData[type].urlGif ===
          '/common/biometrics-scanner/face.gif'
            ? 'face-icon'
            : 'document-icon'
        "
      ></div>
    </div>
    <div class="bi-container__title">{{ instructions.title }}</div>
    <div class="bi-container__text">{{ instructions.subtitle }}</div>
    <div class="bi-container__box">
      <div class="bi-container__text">
        <strong>{{ instructions.boxTitle }}</strong>
      </div>
      <ol class="bi-container__box-list">
        <ng-container
          *ngFor="let instruct of instructions.instructions; let last = last"
        >
          <li>
            {{ instruct }}
          </li>
          <div *ngIf="!last" class="bi-container__divider"></div>
        </ng-container>
      </ol>
    </div>
    <div class="bi-container__btn-container">
      <button
        class="bi-container__btn-container-btn btn btn-degraded blue"
        id="btn"
        (click)="continueFlow()"
      >
        Continuar
      </button>
    </div>
  </div>
</div>
